export type CustomerInfo = {
    email?: string;
    firstName?: string;
    isGuest?: boolean;
    lastName?: string;
};

export function isCustomerInfo(input: CustomerInfo | null): input is CustomerInfo {
    return Boolean(input);
}
